import ActivityRecurringUnit from "@mapmycustomers/shared/enum/activity/ActivityRecurringUnit";
import { Activity } from "@mapmycustomers/shared/types/entity";

import IntervalUnit from "@app/enum/IntervalUnit";

export const parseActivityInterval = (
  interval?: Activity["recurInterval"]
): { unit: ActivityRecurringUnit; value: number } | undefined => {
  const split = interval?.split(" ");
  if (!split) {
    return;
  }
  let canonicalUnit = ActivityRecurringUnit.DAY;
  [ActivityRecurringUnit.MONTH, ActivityRecurringUnit.WEEK, ActivityRecurringUnit.DAY].forEach(
    (unit) => {
      // converting "days" to "day", and so on
      if (split[1].startsWith(unit)) {
        canonicalUnit = unit;
      }
    }
  );
  return {
    unit: canonicalUnit,
    value: parseInt(split[0]),
  };
};

export const stringifyActivityInterval = (interval?: {
  unit: ActivityRecurringUnit | IntervalUnit;
  value: number;
}) =>
  interval?.value && interval?.unit ? [interval.value, interval.unit].join(" ").trim() : undefined;
